<template>
	<div>
		<el-card>
			<div slot="header" class="flex-align-center">
				<el-button type="danger" @click="deleteChange(sels)" :disabled="this.sels.length === 0">批量删除</el-button>
				<el-input class="search-input" v-model="keyword" placeholder="按昵称查找"><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
				<el-select v-model="userStatus" placeholder="用户状态">
					<el-option v-for="item in userStatusOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
				<el-button @click="getUserList" class="search-btn" type="primary">查找</el-button>
			</div>
			<el-table ref="multipleTable" :data="userList" tooltip-effect="dark" style="width: 100%" @selection-change="selsChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="uid" label="ID" width="50"></el-table-column>
				<el-table-column prop="avatar" label="头像" width="80">
					<template slot-scope="scope">
						<el-avatar :size="50" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="用户名" show-overflow-tooltip></el-table-column>
				<el-table-column prop="integral" label="粉丝票"></el-table-column>
				<el-table-column prop="now_money" label="星币余额" show-overflow-tooltip></el-table-column>
				<el-table-column prop="create_time" :formatter="$f.timeFormat" label="注册时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="last_login_time" :formatter="$f.timeFormat" label="最后登录时间" show-overflow-tooltip></el-table-column>
				<el-table-column prop="status" label="状态" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-tooltip :content="'正常/禁用'" placement="top">
							<el-switch
								active-color="#13ce66"
								inactive-color="#ff4949"
								:active-value="0"
								:inactive-value="1"
								v-model="scope.row.status"
								@change="changeStatus(scope.row.uid, scope.row.status)"
							></el-switch>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column width="200px;">
					<template slot-scope="scope">
						<el-button type="danger" @click="deleteUser(scope.row.uid, scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-size="pagesize"
				layout="total,prev,pager,next,jumper"
				:total="userLength"
			></el-pagination>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			sels: [], //选中的值显示
			currentPage: 1, //初始页
			pagesize: 10,
			userList: [],
			userLength: 0,
			dialogVisible: false,
			editUid: null,
			keyword: '',
			userStatus: '',
			userStatusOption: [
				{
					value: '',
					label: '全部'
				},
				{
					value: 0,
					label: '正常'
				},
				{
					value: 1,
					label: '禁用'
				}
			]
		};
	},
	created() {
		this.getUserList();
	},
	methods: {
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage;
			console.log(this.currentPage);
			this.getUserList();
		},
		getUserList() {
			this.$H
				.get('user/list', {
					page: this.currentPage,
					status: this.userStatus,
					keyword: this.keyword
				})
				.then(res => {
					console.log(res);
					this.userList = res.result.data;
					this.userLength = res.result.total;
					this.pagesize = res.result.per_page;
				});
		},
		deleteUser(uid, index) {
			this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				//删除用户的接口
				this.$H
					.post('user/delUser', {
						uid: uid
					})
					.then(res => {
						if (res.code == 200) {
							this.userList.splice(index, 1);
							this.$message.success('删除成功');
						}
					});
			});
		},
		selsChange(sels) {
			this.sels = sels;
		},
		deleteChange(index) {
			var ids = this.sels.map(item => item.uid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
			console.log(ids);
			this.$confirm('此操作将永久删除选中数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.$H
						.post('user/Changedel', {
							uid: ids
						})
						.then(res => {
							if (res.code == 200) {
								this.$message.success('删除成功');
								setTimeout(() => {
									location.reload();
								}, 1000);
							}
						});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		changeStatus(uid, status) {
			this.$H.post('user/userStatus', {
				status: status,
				uid: uid
			});
		}
	}
};
</script>

<style scoped="scoped">
.search-input {
	margin: 0 20px;
	width: 300px;
}

.search-btn {
	margin-left: 20px;
}
</style>
